




























import Vue from 'vue';

import { SnackbarOptions } from '@/services/UI';

import LoadingCircle from '@/components/LoadingCircle.vue';
import MarkdownContent from '@/components/MarkdownContent.vue';

const DEFAULT_LIFETIME = 5000;

export default Vue.extend({
    components: {
        LoadingCircle,
        MarkdownContent,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            required: true,
        },
        options: {
            type: Object as () => SnackbarOptions,
            required: true,
        },
    },
    mounted() {
        if (!this.options.transient)
            return;

        setTimeout(() => this.$ui.hideSnackbar(this.id), this.options.lifetime || DEFAULT_LIFETIME);
    },
    methods: {
        clickAction() {
            if (!this.options.action?.handler)
                return;

            this.options.action.handler();
        },
    },
});
